'use strict'

  cpntMap.set('awe-a11y-announcer', {
  props: {
    availabilities: {
      type: Array,
      default: () => []
    },
    currentTab: {
      type: String,
      default: 'all'
    }
  },
  
  data: function() {
    return {
      message: '',
      updateTimeoutId: 0,
      clearMessageTimeoutId: 0,
      i18n: window.i18n
    }
  },
  
  watch: {
    availabilities: {
      handler: function() {
        this.updateMessage();
      },
      immediate: true
    },
    currentTab: function() {
      this.updateMessage();
    }
  },
  
  methods: {
    updateMessage: function() {
      clearTimeout(this.updateTimeoutId);
      // Debounce updates to prevent rapid-fire announcements when multiple props change simultaneously
      this.updateTimeoutId = setTimeout(() => {
        const hasRetailers = this.availabilities.length > 0;
        let messageKey;
        
        if (hasRetailers) {
          messageKey = 'AVAILABILITIES_ANNOUNCE';
        } else {
          // Use currentTab to determine appropriate error message
          switch (this.currentTab) {
            case 'offline':
              messageKey = 'NOSTORE_OFFLINE';
              break;
            case 'online':
            case 'custom':
              messageKey = 'NOSTORE_ONLINE';
              break;
            case 'all':
            default:
              messageKey = 'NOSTORE_ERROR';
              break;
          }
        }
        
        const message = this.i18n.getString(messageKey);
        
        this.announce(message);
      }, 500);
    },
    
    announce: function(message) {
      // Clear any existing message timeout
      if (this.clearMessageTimeoutId) {
        clearTimeout(this.clearMessageTimeoutId);
      }
      
      this.message = '';
      this.$nextTick(() => {
        this.message = message;
        // Clear message after delay to allow screen readers to announce it and enable re-announcements
        this.clearMessageTimeoutId = setTimeout(() => { 
          this.message = ''; 
        }, 1000);
      });
    }
  },
  
  beforeUnmount: function() {
    // Clean up timeouts to prevent memory leaks
    clearTimeout(this.updateTimeoutId);
    clearTimeout(this.clearMessageTimeoutId);
  },
  
  template: `
    <div 
      id="sr-announcer"
      aria-live="polite" 
      aria-atomic="true"
      class="sr-only"
    >{{ message }}</div>
  `
})
